module.exports = __webpack_public_path__ + "img/card-end-term.141af723.svg";